import { SET_LOGGED_IN, SET_NAME, SET_MESSAGE_STATUS } from './UserMutations'
import api from '@/api'

export default {
  getToken ({ commit }, payload) {
    api
      .getToken(payload)
      .then((response) => {
        if (localStorage.getItem('loggedIn')) {
          commit(SET_LOGGED_IN, true)
          commit(SET_MESSAGE_STATUS, { msg: 'Bine ai venit!', color: 'green' })
          commit(SET_NAME, localStorage.getItem('username'))
        } else {
          commit(SET_LOGGED_IN, false)
          commit(SET_MESSAGE_STATUS, { msg: 'Datele de autentificare nu sunt corecte!', color: 'red' })
          commit(SET_NAME, '')
        }
      })
  },

  logOut ({ commit }, payload) {
    api
      .loggoutUser(payload)
      .then(response => {
        commit(SET_LOGGED_IN, false)
        commit(SET_NAME, '')
      })
      .catch(error => {
        console.log('Error: ', error)
        commit(SET_LOGGED_IN, true)
      })
  },
  checkUser ({ commit }) {
    if (localStorage.getItem('loggedIn')) {
      commit(SET_LOGGED_IN, true)
      commit(SET_MESSAGE_STATUS, { msg: 'Bine ai venit!', color: 'green' })
      commit(SET_NAME, localStorage.getItem('username'))
    } else {
      commit(SET_LOGGED_IN, false)
      commit(SET_MESSAGE_STATUS, { msg: 'Datele de autentificare nu sunt corecte!', color: 'red' })
      commit(SET_NAME, '')
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/user/UserActions.js